/**
 * @file useContextSwitch.ts
 * @description Переход в другой кабинет (phase19.29; phase19.31 — кабинет
 * вкладки, SC21).
 *
 * Общий для меню пользователя в боковой панели (`SidebarUserMenu`) и
 * переключателя в старой шапке (`ContextSwitcher`). С phase19.31 переход —
 * это просто открыть адрес кабинета в ЭТОЙ вкладке: адрес сам выбирает
 * кабинет вкладки (`RequireContextType`), а кабинет сессии не меняется —
 * иначе соседние вкладки со старым кабинетом начали бы работать в новом.
 * Явный выбор кабинета по умолчанию остаётся на странице «Выбор кабинета».
 */

import { useNavigate } from "react-router";

import { landingPathFor } from "../auth/format";
import { useAuth } from "../auth/hooks";
import type { AccountContext } from "../auth/types";

export function useContextSwitch(): (ctx: AccountContext) => Promise<void> {
  const { me } = useAuth();
  const navigate = useNavigate();
  return async (ctx: AccountContext) => {
    // Уже в этом кабинете — переходить некуда.
    if (ctx.id === me?.activeContext?.id) return;
    navigate(landingPathFor(ctx));
  };
}
